import { getH, type H } from './getH';

let platformInstance: H.service.Platform | null = null;
let hereSearchInstance: H.service.SearchService | null = null;

/**
 * Get HERE Platform instance (lazy loaded)
 */
export async function getPlatform(): Promise<H.service.Platform> {
	if (platformInstance) {
		return platformInstance;
	}

	const H = await getH();

	const _platformInstance = new H.service.Platform({
		apikey: 'RJBeP8M9QCqTkJdm0SE-G4kKCoWrWx8am_idQ49z8AY',
	});

	platformInstance = _platformInstance;

	return _platformInstance;
}

/**
 * Get HERE Search Service instance (lazy loaded)
 */
export async function getHereSearch(): Promise<H.service.SearchService> {
	if (hereSearchInstance) {
		return hereSearchInstance;
	}

	const platform = await getPlatform();
	hereSearchInstance = platform.getSearchService();

	return hereSearchInstance;
}
